// extracted by css-extract-rspack-plugin
export default {"unviewedCount":"_4ec6896","isMobile":"_a358f18","mobileIcon":"_398bc4a9"};